/**
 * Contact helpers — phone reveal, WhatsApp, Viber.
 * Public host / email / phone constants live in `@/lib/site-identity`
 * (JetHost DNS for the canonical production host — see docs/ui-ux/SITE_CONTACT.md).
 */

import { PHONE_E164 } from '@/lib/site-identity';

export {
  CANONICAL_HOST,
  CANONICAL_ORIGIN,
  FORMER_BRAND_NAME,
  LEGAL_OPERATOR_NAME,
  LEGACY_REDIRECT_HOSTS,
  LEGACY_SITE_DOMAIN,
  OWNER_NAME,
  PHONE_DISPLAY,
  PHONE_E164,
  PUBLIC_EMAIL,
  SITE_DOMAIN,
  SITE_EMAIL,
  SITE_LEGAL_NAME,
  SITE_SMTP_HOST,
  SITE_URL,
  SITE_WWW,
  VAT_ID,
  getPublicMailtoHref,
} from '@/lib/site-identity';

/** wa.me URL - build at runtime to avoid number in HTML */
export const getWhatsAppUrl = (): string => `https://wa.me/${PHONE_E164.replace('+', '')}`;

/**
 * Viber personal-chat deep link (`viber://chat?number=<digits>`).
 * Digits only, no `+` — the `+` / `%2B` form is ignored by the Viber app.
 */
export const getViberUrl = (): string => `viber://chat?number=${PHONE_E164.replace('+', '')}`;

/**
 * Opens a 1:1 Viber chat with the public contact number.
 *
 * Must run synchronously in a click handler. Browsers treat `viber://` as a
 * custom scheme and silently drop it after an `await` (lost user gesture).
 * HTTP 302 from `/api/contact/viber` is also blocked for custom schemes.
 */
export function openViberChat(): void {
  window.location.assign(getViberUrl());
}
